/**
 * KanbanBucketSkeleton - Skeleton loader za Kanban bucket/kolonu
 * Prikazuje animirani placeholder za bucket sa karticama
 */

import React from 'react';
import { Skeleton, Badge } from 'antd';
import { KanbanCardSkeleton } from './KanbanCardSkeleton';
import './skeletons.css';

interface KanbanBucketSkeletonProps {
  /** Broj skeleton kartica za prikaz u bucket-u */
  cardCount?: number;
}

export const KanbanBucketSkeleton: React.FC<KanbanBucketSkeletonProps> = ({
  cardCount = 3,
}) => {
  return (
    <div className="kanban-bucket kanban-bucket-skeleton">
      <div className="kanban-bucket-header">
        <h3 className="kanban-bucket-title">
          <Skeleton.Input
            active
            size="small"
            style={{ width: 120, height: 16 }}
          />
          <Badge
            count={0}
            showZero
            style={{
              marginLeft: '8px',
              backgroundColor: 'transparent',
              color: '#00b4d8',
              border: '1px solid rgba(0, 180, 216, 0.3)',
              fontSize: '11px',
              fontWeight: 600,
            }}
          />
        </h3>
        <div className="kanban-bucket-add-btn">+</div>
      </div>
      <div className="kanban-bucket-body">
        <button className="kanban-add-item-btn skeleton-shimmer">
          + Dodaj novi tiket
        </button>
        <div className="kanban-bucket-items">
          {Array.from({ length: cardCount }, (_, index) => (
            <KanbanCardSkeleton key={`card-skeleton-${index}`} />
          ))}
        </div>
      </div>
    </div>
  );
};
